import { CAMPAIGN_SEND_FOR_APPROVAL, CAMPAIGN_SEND_FOR_APPROVAL_SUCCESS, CAMPAIGN_SEND_FOR_APPROVAL_ERROR, CAMPAIGN_SEND_FOR_APPROVAL_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CampaignSendForApproval = (state = initialState, action) => {
  switch (action.type) {
    case CAMPAIGN_SEND_FOR_APPROVAL:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CAMPAIGN_SEND_FOR_APPROVAL_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CAMPAIGN_SEND_FOR_APPROVAL_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CAMPAIGN_SEND_FOR_APPROVAL_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CampaignSendForApproval;
